// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"d390928c","990":"d1acf9b8"}[chunkId] + ".chunk.js";
};